import InputLloodSelect from '../InputLloodSelect'
import inputExtend from './inputExtend'

import { getSelectInput, getSelectUsers } from '../../../api/api.js'

/*
TEST HOOKS
const textprueba = inputExtend(InputLloodText, [{
	hook: 'input',
	callback: function (comp, val) {
		return val + ' prueba test'
	}
}], {});
*/

const selectAsync = inputExtend(InputLloodSelect, [], 
{
	props: {
		loading: {
			type: Boolean,
			default: false
		},
		remote: {
			type: Boolean,
			default: true
		},
		input: {
			type: Object
		},
		automaticDropdown: {
			default: true
		}
	},
	methods: {
		async remoteMethod () {

			if (this.remote && this.list && this.list.length) return
			
			this.$parent.$parent.loading = true

			const { data } = await getSelectInput(this.input.lista__id)
			//const data = ["departamento 1","departamento 2","obra","oficina"]

			this.$parent.$parent.loading = false
			
			this.list = data.map(item => {
				return { value: item, label: item.toUpperCase() }
			})
		}
	}
})

const selectAsyncUsers = inputExtend(InputLloodSelect, [], 
{
	props: {
		loading: {
			type: Boolean,
			default: false
		},
		remote: {
			type: Boolean,
			default: true
		},
		input: {
			type: Object
		},
		automaticDropdown: {
			default: true
		}
	},
	methods: {
		async remoteMethod () {

			if (this.remote && this.list && this.list.length) return
			
			this.$parent.$parent.loading = true

			const { data } = await getSelectUsers()
			/*const data = [{
				"id": 1,
				"name": "Administrador",
				"email": "admin@externalizado.com",
				"username": "admin"
			}]*/

			this.$parent.$parent.loading = false
			
			this.list = data.map(item => {
				return { value: item.email, label: item.email}
			})
		}
	}
})

const selectList = inputExtend(InputLloodSelect, [], 
{
	props: {
		options: {
			type: Array,
			default: () => []
		}
	},
	methods: {
		$render (val) {
			return this.options.length ? this.options.find(f => f.value == val).label : val
		}
	}
})

export default {
	'list': selectList,
	selectAsync,
	selectAsyncUsers
}
